import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  message,
  Select,
  Upload,
  Radio,
  Checkbox,
  Row,
  Col,
  Icon
} from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import _ from 'lodash';
import { platformApi } from '../../../../../api';
import { formatValue } from "../../../../../utils"

function InsuranceData({ form, validityRef, data, clearRef, editable, logo, setLogo, setData, error, setError }) {
  const { getFieldDecorator,getFieldValue,setFieldsValue } = form;

  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [booleanstate, setbooleanstate] = useState(true);
  const [booleancity, setbooleancity] = useState(true);
  const [sameAsBilling, setSameAsBilling] = useState(false);
  const [shippingState, setShippingState] = useState([]);
  const [shippingCity, setShippingCity] = useState([]);
  const [shippingBooleanstate, setShippingBooleanstate] = useState(true);
  const [shippingBooleancity, setShippingBooleancity] = useState(true);
  

  const [gstType, setGstType] = useState(false);
  const [gstName, setGstName] = useState('')
  const [gstStatus, setGstStatus] = useState('');

  const handleSameAsBillingChange = (e) => {
    const checked = e.target.checked;
    setSameAsBilling(checked);
    
    if (checked) {
      // Copy billing address to shipping address fields
      const billingLine1 = getFieldValue("address.line1") || "";
      const billingLine2 = getFieldValue("address.line2") || "";
      const billingLine3 = getFieldValue("address.line3") || "";
      const billingLocality = getFieldValue("address.locality") || "";
      const billingPincode = getFieldValue("address.pincode") || "";
      const billingCountry = getFieldValue("address.country") || "";
      const billingState = getFieldValue("address.state") || "";
      const billingDistrict = getFieldValue("address.district") || "";
      
      // Set shipping address fields to billing values
      setFieldsValue({
        shippingLine1: billingLine1,
        shippingLine2: billingLine2,
        shippingLine3: billingLine3,
        shippingLocality: billingLocality,
        shippingPincode: billingPincode,
        shippingCountry: billingCountry,
        shippingState: billingState,
        shippingDistrict: billingDistrict
      });
      
      // Also fetch states and cities for shipping address if needed
      if (billingCountry) {
        platformApi.post('/api/csc/states', { id: billingCountry })
          .then((res) => {
            setShippingState(res.data.data);
            setShippingBooleanstate(false);
          })
          .catch((err) => {
            console.error('Shipping State fetch error :', err);
          });
      }
      if (billingState) {
        platformApi.post('/api/csc/cities', { id: billingState })
          .then((res) => {
            setShippingCity(res.data.data);
            setShippingBooleancity(false);
          })
          .catch((err) => {
            console.error('Shipping Cities fetch error :', err);
          });
      }
    } else {
      // When unchecked, clear shipping address states/cities
      setShippingState([]);
      setShippingCity([]);
      setShippingBooleanstate(true);
      setShippingBooleancity(true);
    }
  };

  useEffect(() => {
    if (sameAsBilling) {
      const billingLine1 = getFieldValue("address.line1") || "";
      const billingLine2 = getFieldValue("address.line2") || "";
      const billingLine3 = getFieldValue("address.line3") || "";
      const billingLocality = getFieldValue("address.locality") || "";
      const billingPincode = getFieldValue("address.pincode") || "";
      const billingCountry = getFieldValue("address.country") || "";
      const billingState = getFieldValue("address.state") || "";
      const billingDistrict = getFieldValue("address.district") || "";
      
      setFieldsValue({
        shippingLine1: billingLine1,
        shippingLine2: billingLine2,
        shippingLine3: billingLine3,
        shippingLocality: billingLocality,
        shippingPincode: billingPincode,
        shippingCountry: billingCountry,
        shippingState: billingState,
        shippingDistrict: billingDistrict
      });
      
      // Also update shipping states/cities when billing address changes
      if (billingCountry) {
        platformApi.post('/api/csc/states', { id: billingCountry })
          .then((res) => {
            setShippingState(res.data.data);
            setShippingBooleanstate(false);
          })
          .catch((err) => {
            console.error('Shipping State fetch error :', err);
          });
      }
      if (billingState) {
        platformApi.post('/api/csc/cities', { id: billingState })
          .then((res) => {
            setShippingCity(res.data.data);
            setShippingBooleancity(false);
          })
          .catch((err) => {
            console.error('Shipping Cities fetch error :', err);
          });
      }
    }
  }, [
    getFieldValue("address.line1"),
    getFieldValue("address.line2"),
    getFieldValue("address.line3"),
    getFieldValue("address.locality"),
    getFieldValue("address.pincode"),
    getFieldValue("address.country"),
    getFieldValue("address.state"),
    getFieldValue("address.district"),
    sameAsBilling
  ]);

  useEffect(() => {
    platformApi.get('/api/csc/country')
      .then((res) => {
        setCountry(res.data.data);
      })
      .catch((err) => {
        message.error('Coudn\'t fetch Countries');
        console.error('Countries fetch error:', err);
      });
    setState([]);
    setCity([]);
    setShippingState([]);
    setShippingCity([]);
    if (data && data.name) {
      if (data.address && data.address.country && data.address.country.id) {
        platformApi.post('/api/csc/states', { id: data.address.country.id })
          .then((res) => {
            setState(res.data.data);
            setbooleanstate(false);
          })
          .catch((err) => {
            message.error('Couldn\'t fetch States');
            console.error('State fetch error :', err);
          });
      }
      if (data.address && data.address.state && data.address.state.id) {
        platformApi.post('/api/csc/cities', { id: data.address.state.id })
          .then((res) => {
            setCity(res.data.data);
            setbooleancity(false);
          })
          .catch((err) => {
            message.error('Couldn\'t fetch Cities');
            console.error('Cities fetch error :', err);
          });
      }

        if (data.shippingAddress && data.shippingAddress.country && data.shippingAddress.country.id) {
          platformApi.post('/api/csc/states', { id: data.shippingAddress.country.id })
            .then((res) => {
              setShippingState(res.data.data);
              setShippingBooleanstate(false);
            })
            .catch((err) => {
              console.error('Shipping State fetch error :', err);
            });
        }
        
        if (data.shippingAddress && data.shippingAddress.state && data.shippingAddress.state.id) {
          platformApi.post('/api/csc/cities', { id: data.shippingAddress.state.id })
            .then((res) => {
              setShippingCity(res.data.data);
              setShippingBooleancity(false);
            })
            .catch((err) => {
              console.error('Shipping Cities fetch error :', err);
            });
        }

      if (data.dealerType === "UnregisteredDealer") {
        setGstType(true);
      }
      if (data.shippingAddress && data.address) {
        const isSameAddress = 
          data.shippingAddress.line1 === data.address.line1 &&
          data.shippingAddress.line2 === data.address.line2 &&
          data.shippingAddress.line3 === data.address.line3 &&
          data.shippingAddress.locality === data.address.locality &&
          data.shippingAddress.pincode === data.address.pincode &&
          (data.shippingAddress.country?.id || data.shippingAddress.country) === 
            (data.address.country?.id || data.address.country) &&
          (data.shippingAddress.state?.id || data.shippingAddress.state) === 
            (data.address.state?.id || data.address.state) &&
          (data.shippingAddress.district?.id || data.shippingAddress.district) === 
            (data.address.district?.id || data.address.district);
        
        setSameAsBilling(isSameAddress);
      }

      form.setFieldsValue({
        name: data.name,
        dealerType: data.dealerType,
        status: data.status,
        GSTIN: data.GSTIN,
        email: data.email,
        phone: data.phone,
        whatsApp: data.whatsApp,
        address: {
          state: data.address && data.address.state?.id,
          country: data.address && data.address.country?.id,
          district: data.address && data.address.district?.id,
          pincode: data.address && data.address.pincode,
          locality: data.address && data.address.locality,
          // street: data.address && data.address.street,
          line1: data.address && data.address.line1,
          line2: data.address && data.address.line2,
          line3: data.address && data.address.line3,
        },
        shippingLine1: data.shippingAddress && data.shippingAddress.line1,
        shippingLine2: data.shippingAddress && data.shippingAddress.line2,
        shippingLine3: data.shippingAddress && data.shippingAddress.line3,
        shippingLocality: data.shippingAddress && data.shippingAddress.locality,
        shippingPincode: data.shippingAddress && data.shippingAddress.pincode,
        shippingCountry: data.shippingAddress && data.shippingAddress.country && data.shippingAddress.country.id,
        shippingState: data.shippingAddress && data.shippingAddress.state && data.shippingAddress.state.id,
        shippingDistrict: data.shippingAddress && data.shippingAddress.district && data.shippingAddress.district.id,
        cashless : data.cashless,
      });
    }
    clearRef.current = () => {
      setGstName('')
      setGstStatus('')
      form.resetFields();
    };
    validityRef.current = () => {
      return validatePage();
    };
    return () => {
      validityRef.current = null;
      clearRef.current = null;
    };
  }, [data]);

  function checkGST(gst) {
    platformApi.post('/api/gstVerify', { gst })
      .then(res => {
        let { data } = res;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            if (response.data.data.error) {
              message.error('GST Invalid')
              setGstName('')
              setGstStatus('')
              return false;
            }
            else {
              message.success('GST Verified')
              const payload = response?.data?.data;
              if(payload.taxpayerInfo?.adadr?.[0]?.addr){
                form.setFieldsValue({
                  "address.locality": payload.taxpayerInfo.adadr[0].addr.loc,
                  "address.pincode": payload.taxpayerInfo.adadr[0].addr.pncd,
                  "address.line1": payload.taxpayerInfo.adadr[0].addr.st,
                  "address.line2": payload.taxpayerInfo.adadr[0].addr.bno,
                  "address.line3": payload.taxpayerInfo.adadr[0].addr.dst,
                });
              }else if(payload.taxpayerInfo?.pradr?.addr){
                form.setFieldsValue({
                  "address.locality": payload.taxpayerInfo.pradr.addr.loc,
                  "address.pincode": payload.taxpayerInfo.pradr.addr.pncd,
                  "address.line1": payload.taxpayerInfo.pradr.addr.st,
                  "address.line2": payload.taxpayerInfo.pradr.addr.bno,
                  "address.line3": payload.taxpayerInfo.pradr.addr.dst,
                });
              }
              delete error.GST;
              setError(error);
              setGstName(response.data.data.taxpayerInfo.tradeNam)
              setGstStatus(response.data.data.taxpayerInfo.sts)
              return true;
            }
          }
        }
      })
  }


  const selectParams = (e, type, addressType = 'billing') => {
    if (type === 'country') {
      platformApi.post('/api/csc/states', { id: e })
        .then((res) => {
          // setState(res.data.data);
          // setbooleanstate(false);
          if (addressType === 'billing') {
            setState(res.data.data);
            setbooleanstate(false);
            form.setFieldsValue({
              address: { state: undefined, district: undefined },
            });
          } else {
            setShippingState(res.data.data);
            setShippingBooleanstate(false);
            form.setFieldsValue({
              shippingState: undefined,
              shippingDistrict: undefined,
            });
          }
        })
        .catch((err) => {
          message.error('Couldn\'t fetch States');
          console.error('State fetch error :', err);
        });
    }
    if (type === 'state') {
      platformApi.post('/api/csc/cities', { id: e })
        .then((res) => {
          // setCity(res.data.data);
          // setbooleancity(false);
          if (addressType === 'billing') {
            setCity(res.data.data);
            setbooleancity(false);
            form.setFieldsValue({
              address: { district: undefined },
            });
          } else {
            setShippingCity(res.data.data);
            setShippingBooleancity(false);
            form.setFieldsValue({
              shippingDistrict: undefined,
            });
          }
        })
        .catch((err) => {
          message.error('Couldn\'t fetch Cities');
          console.error('Cities fetch error :', err);
        });
    }
  };


  const validatePage = () => {
    let isValid;
    form.validateFields((validationError) => {
      isValid = validationError === null && !error.GST;
    });
    if (isValid) {
      const allData = form.getFieldsValue();
      let billingAddress = {
        district: { id: allData.address.district },
        state: { id: allData.address.state },
        country: { id: allData.address.country },
        pincode: allData.address.pincode,
        locality: allData.address.locality,
        line1: allData.address.line1,
        line2: allData.address.line2,
        line3: allData.address.line3,
      };

      let shippingAddressData = {};
      if (sameAsBilling) {
        // Use billing address for shipping
        shippingAddressData = {
          line1: allData.address.line1,
          line2: allData.address.line2,
          line3: allData.address.line3,
          locality: allData.address.locality,
          pincode: allData.address.pincode,
          country: allData.address.country ? { id: allData.address.country } : null,
          state: allData.address.state ? { id: allData.address.state } : null,
          district: allData.address.district ? { id: allData.address.district } : null,
        };
      } else {
        // Get separate shipping address values
        shippingAddressData = {
          line1: allData.shippingLine1 || "",
          line2: allData.shippingLine2 || "",
          line3: allData.shippingLine3 || "",
          locality: allData.shippingLocality || "",
          pincode: allData.shippingPincode || "",
          country: allData.shippingCountry ? { id: allData.shippingCountry } : null,
          state: allData.shippingState ? { id: allData.shippingState } : null,
          district: allData.shippingDistrict ? { id: allData.shippingDistrict } : null,
        };
      }
      let obj1 = {
        id: allData.address.district
      }
      allData.address.district = obj1;
      let obj2 = {
        id: allData.address.state
      }
      allData.address.state = obj2;
      let obj3 = {
        id: allData.address.country
      }
      allData.address.country = obj3;
      if (data && data.contact) {
        allData.contact = data.contact
      }
      if (data && data.bank) {
        allData.bank = data.bank
      }
      setGstName('')
      if (logo) allData.logo = logo;
      const finalData = {
        ...allData,
        address: billingAddress
      };
      setData(finalData)
    }
    return isValid;
  };
  const filterMethod = (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  return (
    
    <Form style={{ marginTop: '3vh' }}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            validateStatus={error.SUPPLIERNAME && error.SUPPLIERNAME.type}
            help={error.SUPPLIERNAME && error.SUPPLIERNAME.message}
            label="Insurer Name">
            {getFieldDecorator('name', {
              rules: [
                {
                  required: true,
                  message: 'Enter Insurer Name!',
                },
                {
                  pattern: /^[a-zA-Z\s,.-]+$/,
                  message: 'Special characters are not allowed!',
                }
              ],
            })(<Input
              pattern="^[a-zA-Z\s,.-]+$"
              onKeyUp={e => {
                const val = e.target.value.replace(/[^a-zA-Z\s,.-]/g, "");
                form.setFieldsValue({
                  name: formatValue({ target: { value: val } }, "allCaps")
                });
              }}
              onInput={(event) => {
                event.target.value = event.target.value.replace(/[^a-zA-Z\s,.-]/g, "");
                if (!event.target.checkValidity()) {
                  setError({
                    ...error,
                    SUPPLIERNAME: {
                      type: "error",
                      message: "Enter Valid Name"
                    }
                  })
                } else {
                  delete error.SUPPLIERNAME
                  setError(error)
                }
              }}
              placeholder="Supplier Name"
              disabled={!editable} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="GST Dealer Type">
            {getFieldDecorator('dealerType', {
              rules: [
                {
                  required: true,
                  message: 'Select GST Dealer Type!',
                },
              ],
            })(<Select
              placeholder="GST Dealer Type"
              disabled={!editable}
              showAction={["click", "focus"]}
              onChange={(e) => {
                e === "UnregisteredDealer" ? (setGstType(true), setGstName(''), form.setFieldsValue({ GSTIN: undefined }), setError({})) : setGstType(false)
              }}
            >
              <Select.Option value="RegisteredDealer">Registered Dealer</Select.Option>
              <Select.Option value="UnregisteredDealer">Unregistered Dealer</Select.Option>
              <Select.Option value="UINHolder">UIN Holder</Select.Option>
              <Select.Option value="CompositionDealer">Composition Dealer</Select.Option>
            </Select>)}
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Status">
            {getFieldDecorator('status', {
              rules: [
                {
                  required: true,
                  message: 'Select Status!',
                },
              ],
            })(<Select
              showAction={["click", "focus"]}
              placeholder="Status"
              disabled={!editable}
            >
              <Select.Option value="ACTIVE">Active</Select.Option>
              <Select.Option value="INACTIVE">Inactive</Select.Option>
            </Select>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="GSTIN"
            validateStatus={error.GST && error.GST.type}
            help={error.GST && error.GST.message}
            required={!gstType}
          >
            {getFieldDecorator('GSTIN', {
              rules: [
                {
                  required: !gstType,
                  message: 'Enter GST number!',
                },
              ],
            })(<Input
              placeholder="GSTIN"
              maxLength={15}
              onKeyUp={event => {
                form.setFieldsValue({
                  GSTIN: formatValue(event, "toUpperCase")
                })
              }}
              disabled={!editable || gstType}
              // pattern="^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[0-9]{1}[Zz]{1}[0-9A-Za-z]{1}$"
              onInput={(event) => {
                if (event.target.value.length === 15) {
                  let flag = checkGST(event.target.value)
                  if (flag) {
                    delete error.GST;
                    setError(error);
                  }
                  else {
                    setError({
                      ...error,
                      GST: {
                        type: "error",
                        message: "Enter Valid GSTIN",
                      },
                    });
                  }
                }
                else if (gstStatus != "Active") {
                  setGstStatus('')
                  setGstName('')
                  setError({
                    ...error,
                    GST: {
                      type: "error",
                      message: "The GSTIN entered is Inactive"
                    }
                  })
                }
                else {
                  setGstName('')
                  setError({
                    ...error,
                    GST: {
                      type: "error",
                      message: "Enter Valid GSTIN",
                    },
                  });
                }
              }}
            />)}
          </Form.Item>
          {gstName && (
            <Row type="flex" align="middle">
              <Icon
                style={{ fontSize: 18, marginRight: ".5rem" }}
                type={
                  "check-circle"
                }
                twoToneColor={
                  "#D00"
                }
              />
              <span style={{ color: 'green', fontSize: '12px' }}>{gstName} ({gstStatus})</span>
            </Row>
          )}
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            validateStatus={error.EMAIL && error.EMAIL.type}
            help={error.EMAIL && error.EMAIL.message}
            label="Email">
            {getFieldDecorator('email', {
              rules: [
                {
                  required: false,
                  type: 'email',
                  message: 'Enter valid Email!',
                },
              ],
            })(<Input
              placeholder="Email"
              disabled={!editable}
              onInput={(event) => {
                if (!event.target.checkValidity()) {
                  setError({
                    ...error,
                    EMAIL: {
                      type: "error",
                      message: "Enter Valid Email"
                    }
                  })
                } else {
                  delete error.EMAIL
                  setError(error)
                }
              }}
            />)}
          </Form.Item>
        </Col>
        <Col span={12}>
    <Form.Item label="Cashless">
      {getFieldDecorator("cashless", {
        rules: [{ required: true, message: "Select Cashless!" }],
      })(
        <Radio.Group disabled={!editable}>
          <Radio value="YES">Yes</Radio>
          <Radio value="NO">No</Radio>
        </Radio.Group>
      )}
    </Form.Item>
  </Col>
        
      </Row>
      <br/>
      <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 15 }}>
        Billing Address
      </div>

      <Row gutter={16}>
      <Col span={12}>
          <Form.Item
            validateStatus={error.LINE1 && error.LINE1.type}
            help={error.LINE1 && error.LINE1.message}
            label="Address Line 1">
            {getFieldDecorator('address.line1', {
              rules: [
                {
                  required: !gstType,
                  message: 'Enter Address Line 1!',
                },
                {
                  pattern: /^[a-zA-Z0-9\s,./#():-]+$/,
                  message: "Special characters are not allowed!",
                },
              ],
            })(<Input
              onKeyUp={e => {
                const val = e.target.value.replace(/[^a-zA-Z0-9\s,./#():-]/g, "");
                form.setFieldsValue({
                  "address.line1": formatValue({ target: { value: val } }, "allCaps")
                });
              }}
              onInput={(event) => {
                event.target.value = event.target.value.replace(/[^a-zA-Z0-9\s,./#():-]/g, "");
                if (!event.target.checkValidity()) {
                  setError({
                    ...error,
                    LINE1: {
                      type: "error",
                      message: "Enter Valid Address"
                    }
                  })
                } else {
                  delete error.LINE1
                  setError(error)
                }
              }}
              maxLength={60}
              placeholder="Address Line 1"
              disabled={!editable} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            validateStatus={error.LINE2 && error.LINE2.type}
            help={error.LINE2 && error.LINE2.message}
            label="Address Line 2">
            {getFieldDecorator('address.line2', {
              rules: [
                {
                  required: false,
                },
                {
                  pattern: /^[a-zA-Z0-9\s,./#():-]+$/,
                  message: "Special characters are not allowed!",
                },
              ],
            })(<Input
              onKeyUp={e => {
                const val = e.target.value.replace(/[^a-zA-Z0-9\s,./#():-]/g, "");
                form.setFieldsValue({
                  "address.line2": formatValue({ target: { value: val } }, "allCaps")
                });
              }}
              onInput={(event) => {
                event.target.value = event.target.value.replace(/[^a-zA-Z0-9\s,./#():-]/g, "");
                if (!event.target.checkValidity()) {
                  setError({
                    ...error,
                    LINE2: {
                      type: "error",
                      message: "Enter Valid Address Line 2"
                    }
                  })
                } else {
                  delete error.LINE2
                  setError(error)
                }
              }}
              maxLength={60}
              placeholder="Address Line 2"
              disabled={!editable} />)}
          </Form.Item>
        </Col>
        
      </Row>

      <Row gutter={16}>
      <Col span={12}>
          <Form.Item
            validateStatus={error.LINE3 && error.LINE3.type}
            help={error.LINE3 && error.LINE3.message}
            label="Address Line 3">
            {getFieldDecorator('address.line3', {
              rules: [
                {
                  required: false,
                },
                {
                  pattern: /^[a-zA-Z0-9\s,./#():-]+$/,
                  message: "Special characters are not allowed!",
                },
              ],
            })(<Input
              onKeyUp={e => {
                const val = e.target.value.replace(/[^a-zA-Z0-9\s,./#():-]/g, "");
                form.setFieldsValue({
                  "address.line3": formatValue({ target: { value: val } }, "allCaps")
                });
              }}
              onInput={(event) => {
                event.target.value = event.target.value.replace(/[^a-zA-Z0-9\s,./#():-]/g, "");
                if (!event.target.checkValidity()) {
                  setError({
                    ...error,
                    LINE3: {
                      type: "error",
                      message: "Enter Valid Address"
                    }
                  })
                } else {
                  delete error.LINE3
                  setError(error)
                }
              }}
              maxLength={60}
              placeholder="Address Line 3"
              disabled={!editable} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            validateStatus={error.LOCALITY && error.LOCALITY.type}
            help={error.LOCALITY && error.LOCALITY.message}
            label="Locality">
            {getFieldDecorator('address.locality', {
              rules: [
                {
                  required: !gstType,
                  message: 'Enter Locality!',
                },
                {
                  pattern: /^[a-zA-Z0-9\s,./-]+$/,
                  message: 'Special characters are not allowed!',
                }
              ],
            })(<Input
              pattern="^[a-zA-Z0-9\s,./-]+$"
              onKeyUp={e => {
                const val = e.target.value.replace(/[^a-zA-Z0-9\s,./-]/g, "");
                form.setFieldsValue({
                  address: {
                    locality: formatValue({ target: { value: val } }, "allCaps")
                  }
                });
              }}
              onInput={(event) => {
                event.target.value = event.target.value.replace(/[^a-zA-Z0-9\s,./-]/g, "");
                if (!event.target.checkValidity()) {
                  setError({
                    ...error,
                    LOCALITY: {
                      type: "error",
                      message: "Enter Valid Locality"
                    }
                  })
                } else {
                  delete error.LOCALITY
                  setError(error)
                }
              }}
              maxLength={50}
              placeholder="Locality"
              disabled={!editable} />)}
          </Form.Item>
        </Col>
        
      </Row>

      <Row gutter={16}>
      <Col span={12}>
          <FormItem label="Country:">
            {getFieldDecorator('address.country', {
              rules: [
                { required: !gstType, message: 'Select Country!' },
              ],
            })(
              <Select
                showAction={["click", "focus"]}
                placeholder="Select Country"
                filterOption={filterMethod}
                onSelect={e => {
                  selectParams(e, 'country');
                  form.setFieldsValue({
                    address: { state: undefined, district: undefined },
                  })
                }
                }
                showSearch
                style={{ width: '100%' }}
                disabled={!editable}
              >
                {country.map(d => (
                  <Select.Option key={d.id} value={d.id}>{d.name}</Select.Option>
                ))}
              </Select>,
            )}
          </FormItem>
        </Col>
        <Col span={12}>
          <Form.Item label="State">
            {getFieldDecorator('address.state', {
              rules: [
                {
                  required: !gstType,
                  message: 'Select State!',
                },
              ],
            })(<Select
              showAction={["click", "focus"]}
              placeholder="Select State"
              disabled={!editable || booleanstate}
              filterOption={filterMethod}
              onSelect={e => {
                selectParams(e, 'state'),
                  form.setFieldsValue({
                    address: { district: undefined },
                  })
              }
              }
              showSearch
              style={{ width: '100%' }}
            >
              {state.map(d => (
                <Select.Option key={d.id} value={d.id}>{d.name}</Select.Option>
              ))}
            </Select>)}
          </Form.Item>
        </Col>
        
      </Row>

      <Row gutter={16}>
      <Col span={12}>
          <FormItem label="City:">
            {getFieldDecorator('address.district', {
              rules: [
                { required: !gstType, message: 'Select City!' },
              ],
            })(
              <Select
                showAction={["click", "focus"]}
                placeholder="Select City"
                disabled={!editable || booleancity}
                filterOption={filterMethod}
                showSearch
                style={{ width: '100%' }}
              >
                {city.map(d => (
                  <Select.Option key={d.id} value={d.id}>{d.name}</Select.Option>
                ))}
              </Select>,
            )}
          </FormItem>
        </Col>
  {/* Pincode Field */}
        <Col span={12}>
          <Form.Item
            validateStatus={error.PIN && error.PIN.type}
            help={error.PIN && error.PIN.message}
            label="Pincode"
          >
            {getFieldDecorator("address.pincode", {
              rules: [{ required: !gstType, message: "Enter PIN Code!" }],
            })(
              <Input
                maxLength={7}
                placeholder="Pincode"
                disabled={!editable}
                onKeyUp={(e) =>
                  form.setFieldsValue({
                    "address.pincode": formatValue(e, "onlyNo"),
                  })
                }
                pattern="([0-9]{6}|[0-9]{3}\\s[0-9]{3})"
                onInput={(event) => {
                  if (!event.target.checkValidity()) {
                    setError({
                      ...error,
                      PIN: {
                        type: "error",
                        message: "Enter Valid PIN Code",
                      },
                    });
                  } else {
                    delete error.PIN;
                    setError(error);
                  }
                }}
              />
            )}
          </Form.Item>
        </Col>
        
        </Row>
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 15 }}>
          Shipping Address
        </div>
        <Row style={{ marginBottom: 16 }}>
        <Col span={24}>
          <Checkbox
            checked={sameAsBilling}
            onChange={handleSameAsBillingChange}
            disabled={!editable}
          >
            Shipping address same as Billing address
          </Checkbox>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Address Line 1"
            validateStatus={error.SHIPPING_LINE1 && error.SHIPPING_LINE1.type}
            help={error.SHIPPING_LINE1 && error.SHIPPING_LINE1.message}
          >
            {getFieldDecorator('shippingLine1', {
              rules: [
                {
                  required: !gstType && !sameAsBilling,
                  message: 'Enter Address Line 1!',
                },
                {
                  pattern: /^[a-zA-Z0-9\s,./#():-]+$/,
                  message: "Special characters are not allowed!",
                },
              ],
            })(<Input
              onKeyUp={e => {
                const val = e.target.value.replace(/[^a-zA-Z0-9\s,./#():-]/g, "");
                setFieldsValue({
                  shippingLine1: formatValue({ target: { value: val } }, "allCaps")
                });
              }}
              onInput={(event) => {
                event.target.value = event.target.value.replace(/[^a-zA-Z0-9\s,./#():-]/g, "");
              }}
              maxLength={60}
              placeholder="Address Line 1"
              disabled={!editable || sameAsBilling} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Address Line 2"
            validateStatus={error.SHIPPING_LINE2 && error.SHIPPING_LINE2.type}
            help={error.SHIPPING_LINE2 && error.SHIPPING_LINE2.message}
          >
            {getFieldDecorator('shippingLine2', {
              rules: [
                {
                  required: false,
                },
                {
                  pattern: /^[a-zA-Z0-9\s,./#():-]+$/,
                  message: "Special characters are not allowed!",
                },
              ],
            })(<Input
              onKeyUp={e => {
                const val = e.target.value.replace(/[^a-zA-Z0-9\s,./#():-]/g, "");
                setFieldsValue({
                  shippingLine2: formatValue({ target: { value: val } }, "allCaps")
                });
              }}
              onInput={(event) => {
                event.target.value = event.target.value.replace(/[^a-zA-Z0-9\s,./#():-]/g, "");
              }}
              maxLength={60}
              placeholder="Address Line 2"
              disabled={!editable || sameAsBilling} />)}
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Address Line 3"
            validateStatus={error.SHIPPING_LINE3 && error.SHIPPING_LINE3.type}
            help={error.SHIPPING_LINE3 && error.SHIPPING_LINE3.message}
          >
            {getFieldDecorator('shippingLine3', {
              rules: [
                {
                  required: false,
                },
                {
                  pattern: /^[a-zA-Z0-9\s,./#():-]+$/,
                  message: "Special characters are not allowed!",
                },
              ],
            })(<Input
              onKeyUp={e => {
                const val = e.target.value.replace(/[^a-zA-Z0-9\s,./#():-]/g, "");
                setFieldsValue({
                  shippingLine3: formatValue({ target: { value: val } }, "allCaps")
                });
              }}
              onInput={(event) => {
                event.target.value = event.target.value.replace(/[^a-zA-Z0-9\s,./#():-]/g, "");
              }}
              maxLength={60}
              placeholder="Address Line 3"
              disabled={!editable || sameAsBilling} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Locality"
            validateStatus={error.SHIPPING_LOCALITY && error.SHIPPING_LOCALITY.type}
            help={error.SHIPPING_LOCALITY && error.SHIPPING_LOCALITY.message}
          >
            {getFieldDecorator('shippingLocality', {
              rules: [
                {
                  required: !gstType && !sameAsBilling,
                  message: 'Enter Locality!',
                },
                {
                  pattern: /^[a-zA-Z0-9\s,./-]+$/,
                  message: 'Special characters are not allowed!',
                }
              ],
            })(<Input
              pattern="^[a-zA-Z0-9\s,./-]+$"
              onKeyUp={e => {
                const val = e.target.value.replace(/[^a-zA-Z0-9\s,./-]/g, "");
                setFieldsValue({
                  shippingLocality: formatValue({ target: { value: val } }, "allCaps")
                });
              }}
              onInput={(event) => {
                event.target.value = event.target.value.replace(/[^a-zA-Z0-9\s,./-]/g, "");
              }}
              maxLength={50}
              placeholder="Locality"
              disabled={!editable || sameAsBilling} />)}
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Country">
            {getFieldDecorator('shippingCountry', {
              rules: [
                {
                  required: !gstType && !sameAsBilling,
                  message: 'Select Country!',
                },
              ],
            })(
              <Select
                showAction={["click", "focus"]}
                placeholder="Select Country"
                filterOption={filterMethod}
                onSelect={e => {
                  selectParams(e, 'country', 'shipping');
                }}
                showSearch
                style={{ width: '100%' }}
                disabled={!editable || sameAsBilling}
              >
                {country.map(d => (
                  <Select.Option key={d.id} value={d.id}>{d.name}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="State">
            {getFieldDecorator('shippingState', {
              rules: [
                {
                  required: !gstType && !sameAsBilling,
                  message: 'Select State!',
                },
              ],
            })(<Select
              showAction={["click", "focus"]}
              placeholder="Select State"
              disabled={!editable || sameAsBilling || shippingBooleanstate}
              filterOption={filterMethod}
              onSelect={e => {
                selectParams(e, 'state', 'shipping');
              }}
              showSearch
              style={{ width: '100%' }}
            >
              {shippingState.map(d => (
                <Select.Option key={d.id} value={d.id}>{d.name}</Select.Option>
              ))}
            </Select>)}
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="City">
            {getFieldDecorator('shippingDistrict', {
              rules: [
                {
                  required: !gstType && !sameAsBilling,
                  message: 'Select City!',
                },
              ],
            })(
              <Select
                showAction={["click", "focus"]}
                placeholder="Select City"
                disabled={!editable || sameAsBilling || shippingBooleancity}
                filterOption={filterMethod}
                showSearch
                style={{ width: '100%' }}
              >
                {shippingCity.map(d => (
                  <Select.Option key={d.id} value={d.id}>{d.name}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Pincode"
            validateStatus={error.SHIPPING_PIN && error.SHIPPING_PIN.type}
            help={error.SHIPPING_PIN && error.SHIPPING_PIN.message}
          >
            {getFieldDecorator('shippingPincode', {
              rules: [
                {
                  required: !gstType && !sameAsBilling,
                  message: 'Enter PIN Code!',
                },
              ],
            })(<Input
              maxLength={7}
              placeholder="Pincode"
              disabled={!editable || sameAsBilling}
              onKeyUp={e =>
                setFieldsValue({
                  shippingPincode: formatValue(e, "onlyNo")
                })}
              pattern="([0-9]{6}|[0-9]{3}\s[0-9]{3})"
              onInput={(event) => {
                if (!event.target.checkValidity()) {
                  setError({
                    ...error,
                    SHIPPING_PIN: {
                      type: "error",
                      message: "Enter Valid PIN Code",
                    },
                  });
                } else {
                  delete error.SHIPPING_PIN;
                  setError(error);
                }
              }}
            />)}
          </Form.Item>
        </Col>
      </Row>
        <Row gutter={16}>
      {/* Insurance Logo Upload Field */}
      <Col span={12}>
          <Form.Item label="Insurance Logo">
            <Upload.Dragger
              disabled={!editable}
              showUploadList={false}
              style={{
                borderRadius: 8,
                padding: "20px",
                minHeight: 220, // 🔹 Slightly bigger visually
              }}
              customRequest={async ({ file, onSuccess, onError }) => {
                try {
                  const formData = new FormData();
                  formData.append("profile", file);
                  formData.append("master", "Company Master");
                  formData.append("module", "Insurance");
                  formData.append("type", "logo");

                  const res = await platformApi.post("/api/upload/image", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                  });

                  const uploadedUrl =
                    res.data?.response?.data?.Location || res.data?.response?.data;

                  if (uploadedUrl) {
                    setLogo(uploadedUrl);
                    setData({ ...data, logo: uploadedUrl });
                    message.success("Logo uploaded successfully!");
                    onSuccess(res.data, file);
                  } else {
                    throw new Error("Invalid upload response");
                  }
                } catch (err) {
                  console.error("Upload failed:", err);
                  message.error("Upload failed!");
                  onError(err);
                }
              }}
              accept=".jpg,.jpeg,.png"
            >
              {logo ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 180,
                  }}
                >
                  <img
                    src={logo}
                    alt="Insurance Logo"
                    style={{
                      width: "auto",
                      height: "90%",
                      maxHeight: 180,
                      objectFit: "contain",
                    }}
                  />
                </div>
              ) : (
                <div>
                  <p className="ant-upload-drag-icon">
                    <Icon type="inbox" />
                  </p>
                  <p className="ant-upload-hint">Click or drag logo to upload</p>
                </div>
              )}
            </Upload.Dragger>
          </Form.Item>
        </Col>
      </Row>


    </Form>

  )
}
const WrappedInsuranceDataForm = Form.create({ name: 'Insurance Form' })(InsuranceData);
export default WrappedInsuranceDataForm;